import { SET_IS_LOADING, SET_VEHICLE_DAMAGE_LIST } from './constants';

const defaultState = {
  list: [],
  isLoading: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading
      }
    }
    case SET_VEHICLE_DAMAGE_LIST: {
      return {
        ...state,
        list: action.result
      }
    }
    default: {
      return state;
    }
  }
}